import { z } from 'zod';

export const Vessel = z.object({
  id: z.number(),
  vessel: z.string(),
  callsign: z.string(),
});

export type Vessel = z.infer<typeof Vessel>;
